/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import noop from "lodash/fp/noop";
import {
  CellEntity as CellEntityType,
  TypeEnum,
} from "../../../../ColumnTemplatePositionEditor/types";
import { TableColumns, TableRow } from "../../../../../../requests/table/types";
import LabelCell from "./LabelCell";
import ValueCell from "./ValueCell";
import {
  ColumnFormatDict,
  Delimiters,
} from "../../../../../../requests/templates/types";
import { columnFormatPLACEHOLDER } from "../../../../../../requests/templates/types/placeholderData";
import { UpdateTableRowCell } from "../../../TableDataDesktop/TableDataRow/TableDataRow";
import DelimiterEntity from "./DelimiterEntity";

export const CellEntity: FC<Props> = ({
  entity,
  row,
  columns,
  formatDict,
  editMode,
  onCellEdit = noop,
  onCellBlur,
  tableRowCallback,
  delimiters,
}) => {
  const { type, presentationTemplateItemId, delimiterId } = entity;

  const format =
    formatDict[presentationTemplateItemId] || columnFormatPLACEHOLDER;

  const column = Object.values(columns).find(
    (col) => col.templateItemId === presentationTemplateItemId
  );

  if (type === TypeEnum.empty) {
    return <Fragment>&nbsp;</Fragment>;
  }

  if (type === TypeEnum.delimiter) {
    const { delimiterPatternId } = delimiters[delimiterId];
    return <DelimiterEntity delimiterPatternId={delimiterPatternId} />;
  }

  if (!column || !format || column.inputType === "hidden") {
    return <div />;
  }

  if (type === TypeEnum.label) {
    return <LabelCell column={column} format={format.label} />;
  }

  if (type === TypeEnum.value) {
    return (
      <ValueCell
        row={row}
        column={column}
        format={format.value}
        editMode={editMode}
        onInputChange={(newValue) => onCellEdit(column.columnAlias, newValue)}
        onInputBlur={onCellBlur}
        tableRowCallback={tableRowCallback}
      />
    );
  }

  return <div />;
};

export default CellEntity;
interface Props {
  entity: CellEntityType;
  row: TableRow;
  delimiters: Delimiters;
  columns: TableColumns;
  formatDict: ColumnFormatDict;
  editMode?: boolean;
  onCellEdit?: UpdateTableRowCell;
  onCellBlur?(): void;
  tableRowCallback?(): void;
}

export type CellEntityProps = Props;
